import { createStyles, makeStyles } from '@material-ui/core/styles';
import { BORDER_GRAY, LIGHT_PRIMARY } from 'constants/colors';
export default makeStyles(theme => createStyles({
  depositDisplay: {
    display: 'grid',
    gridTemplateColumns: 'auto minmax(210px, 1.5fr) 1fr 0.9fr auto',
    alignItems: 'center',
    minHeight: theme.spacing(10.5),
    padding: theme.spacing(1.5, 2),
    border: `1px solid ${BORDER_GRAY}`,
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: 'auto 1fr',
      alignItems: 'start'
    }
  },
  depositSection: {
    minHeight: theme.spacing(6),
    padding: theme.spacing(0, 2),
    borderLeft: `1px solid ${BORDER_GRAY}`,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    '&:nth-child(2)': {
      borderLeft: 0
    },
    '& b': {
      fontSize: '0.84rem'
    },
    '& p': {
      marginTop: theme.spacing(0.5),
      fontSize: '0.82rem'
    },
    [theme.breakpoints.down('sm')]: {
      gridColumn: '2',
      width: '100%',
      minHeight: theme.spacing(5),
      padding: theme.spacing(0, 1),
      borderLeft: 0
    }
  },
  iconCircle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: theme.spacing(6),
    height: theme.spacing(6),
    borderRadius: '50%',
    backgroundColor: LIGHT_PRIMARY,
    marginRight: theme.spacing(1),
    color: theme.palette.text.primary
  },
  status: {
    alignSelf: 'flex-start',
    height: theme.spacing(2.75),
    marginTop: theme.spacing(0.5),
    color: theme.palette.text.primary,
    backgroundColor: LIGHT_PRIMARY,
    '& .MuiChip-label': {
      padding: theme.spacing(0, 1),
      fontSize: '0.75rem',
      fontWeight: 500
    }
  },
  seeDetails: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    color: theme.palette.primary.main,
    fontWeight: 600,
    cursor: 'pointer',
    background: 'none',
    border: 'none',
    padding: theme.spacing(1, 0),
    fontSize: '0.82rem',
    whiteSpace: 'nowrap',
    '&:hover': {
      textDecoration: 'underline'
    }
  }
}));